export enum ContractType {
  RATE_CARD = 'RATE_CARD',
  CUSTOMER_CONTRACT = 'CUSTOMER_CONTRACT',
  SUPPLIER_CONTRACT = 'SUPPLIER_CONTRACT'
}
